module.exports = __webpack_public_path__ + "media/images/gallery/aurorae/2001-11-05/23-2f8a30cfed491849ed9dcaea7bcbed08.jpg";